import cn from "classnames";
import { convertValueToLocale } from "helpers/convertValueToLocale";

import { Typography } from "shared/ui/components/Typography";

import { DetailedTable } from "../DetailedTable";

import styles from "./PenaltyCard.module.scss";

const renderValueByKey = (value: any, key: string) => {
  switch (key) {
    case "quantity":
      return convertValueToLocale(value, null, "€", null);
    default:
      return value;
  }
};

const _cellRenderer = ({
  className,
  item,
  key,
  justifyContent,
  cellType,
  minWidth,
  maxWidth,
}) => {
  switch (key) {
    default: {
      const value =
        cellType !== "boolean" ? item[key] || "" : item[key] || false;

      const type = item?.type;

      return (
        <div
          className={cn(styles.cell, className)}
          key={key}
          style={{
            minWidth,
            maxWidth,
            justifyContent: justifyContent,
            padding: "8px 12px",
          }}
        >
          <Typography
            className={cn(styles.text, {
              [styles.sumText]: type === "Summe",
            })}
            variant="numbers"
          >
            {renderValueByKey(value, key)}
          </Typography>
        </div>
      );
    }
  }
};

const PenaltyCard = ({ items, columns }: any) => {
  return (
    <DetailedTable
      title="Einmalige Finanzierungskosten"
      data={items}
      columns={columns}
      cellRenderer={(props) => _cellRenderer(props)}
    />
  );
};

export default PenaltyCard;
